// @flow

import React, { type Node } from 'react';

import { OtpFinish } from './otp-finish';
import { OtpForm } from './otp-form';

import { useIncomingPayment } from '@tectonics/prs/incoming-payment';

export function OtpPage(): Node {
  const incomingPayment = useIncomingPayment();
  if (incomingPayment.hasOwnProperty('status_otp') && incomingPayment.status_otp === 'authenticated') {
    return (<OtpFinish />);
  }
  return (<OtpForm />);
}
